import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { STPMPCBParameterPostDataAPI } from '../../../../../Redux/STPDashboardSlice/STPSidebarMaster/STPMPCBParameterSlice';


export default function STPMPCBParameterMasterPopup(props) {

    const { handleOnCloseClick, open, EditIcon, Flag, GardenMasterFlag, popupHeading, M_AssetTypeID, handleIsPost, apiFlag, rowData, HWard, WLable } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [MPCBParameterTextField, setMPCBParameterTextField] = useState({
        mpcbParameter: Flag === 'Update' ? rowData.mpcbParameter : '',
        unit: Flag === 'Update' ? rowData.unit : '',
    });

    const handleMPCBParameterTextField = (e) => {
        setMPCBParameterTextField({ ...MPCBParameterTextField, [e.target.name]: e.target.value })
    }

    const handlePost = () => {
        const data = {
            M_STP_MPCBParameterID: Flag === 'Update' ? rowData.m_stP_MPCBParameterID : '0',
            MPCBParameter: MPCBParameterTextField.mpcbParameter,
            Unit: MPCBParameterTextField.unit,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
        }
        dispatch(STPMPCBParameterPostDataAPI({ data }))
    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">MPCB Parameter Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">

                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>MPCB Parameter </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="mpcbParameter"
                                            name='mpcbParameter'
                                            value={MPCBParameterTextField.mpcbParameter}
                                            onChange={(e) => handleMPCBParameterTextField(e)}
                                        />

                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Unit </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="unit"
                                            name='unit'
                                            value={MPCBParameterTextField.unit}
                                            onChange={(e) => handleMPCBParameterTextField(e)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12 pt-lg-5 pt-md-4 pt-3">
                                <div className="btn-action d-flex justify-content-end">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            MPCBParameterTextField.mpcbParameter == '' || MPCBParameterTextField.unit == '' 
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button typtton type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}